// @flow
// $FlowFixMe
import React, { useRef, type Node } from "react";
import MobileHeader from "@fdr/mobile-header";
import { Containers } from "@fdr/static-ui/BaseComponents";
import type { GeolocationStatus } from "@tvg/sh-geolocation/src/utils/requestGeolocation";
import CrossProductNavigation from "./CrossProductNavigation";
import { Container } from "../style/header-styled";

type Props = {
  title: string,
  logoMod: string,
  currentPath: string,
  isLogged: boolean,
  isVisible: boolean,
  isActionToolsShown: boolean,
  isBigHeader?: boolean,
  device: string,
  prevPath: string,
  backgroundColor: string,
  color: string,
  arrowColor: string,
  children: Node,
  hasCrossNavigation?: boolean,
  iconSize: number,
  fontSize: number,
  height: number,
  align: string,
  hasBottomBorder: boolean,
  geolocationStatus?: GeolocationStatus,
  onlyBanner?: boolean
};

const headerHeight = (childrenRef, isBigHeader) => {
  const baseHeaderHeight = isBigHeader ? 56 : 48;

  return childrenRef.current
    ? childrenRef.current.offsetHeight + baseHeaderHeight
    : baseHeaderHeight;
};

const Header = ({
  title,
  logoMod,
  isLogged,
  isVisible,
  isActionToolsShown,
  isBigHeader,
  device,
  currentPath,
  backgroundColor,
  color,
  arrowColor,
  prevPath,
  children,
  hasCrossNavigation,
  iconSize,
  fontSize,
  height,
  align,
  hasBottomBorder,
  geolocationStatus,
  onlyBanner
}: Props) => {
  const childrenRef = useRef(null);
  return (
    <Containers.Header
      device={device}
      isVisible={isVisible}
      headerHeight={headerHeight(childrenRef, isBigHeader)}
    >
      {hasCrossNavigation && (
        <div>
          <CrossProductNavigation />
        </div>
      )}
      <Container geolocationStatus={geolocationStatus} onlyBanner={onlyBanner}>
        <MobileHeader
          title={title}
          logoMod={logoMod}
          quickDepositUrl={`${currentPath}#deposit`}
          prevPath={prevPath}
          isLogged={isLogged}
          isActionToolsShown={isActionToolsShown}
          backgroundColor={backgroundColor}
          color={color}
          arrowColor={arrowColor}
          iconSize={iconSize}
          fontSize={fontSize}
          height={height}
          align={align}
          hasBottomBorder={hasBottomBorder}
        />
        <div ref={childrenRef}>{children}</div>
      </Container>
    </Containers.Header>
  );
};

export default Header;
